$(document).ready(function() {
  if($('#tab1 table th').length == 5){
     $('.size-tabs table').addClass('five-columns');
  }
});

$("document").ready(function(){
  $(".tab-slider--container .tab-slider--body").hide();
  $(".tab-slider--container").each(function() {
    $(".tab-slider--container .tab-slider--body:first-of-type").show();
  });
});

$(".tab-slider--nav li").click(function() {
  $(".tab-slider--body").hide();
  var activeTab = $(this).attr("rel");
  $('[id="' + activeTab + '"]').fadeIn();
	if($(this).attr("rel") == "tab2"){
		$('.tab-slider--tabs').addClass('slide');
	}else{
		$('.tab-slider--tabs').removeClass('slide');
	}
  $(".tab-slider--nav li").removeClass("active");
  $('[rel="' + activeTab + '"]').addClass("active");
});


$(document).on('click', '.giftwrap-add-to-cart', function(e) {
  e.preventDefault();

  let variant_id = Number($(this).data('variant'));
  var data = {
    "id": variant_id,
    "quantity": 1
  }
  jQuery.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: data,
    dataType: 'json',
    success: function() { 
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true,  //this code is for prestige theme, is to refresh the cart
        detail: {
          quantity: 1
        }
      }));
    }   
  }); 
})

document.addEventListener('variant:change', function(event) {
  let addToCartButtonElement = this.querySelector('.shopify-section--main-product [data-block-type="buy-buttons"] .buy-buttons .button');
  let variantPreorderData = {};
  let variantPreorderDataScript = document.querySelector("#variant-preorder-data");
  let variantPreorderMessage = document.querySelector("#variant-preorder-message");
  let variantPreorderProperty = document.querySelector("#variant-preorder-property");
  if (variantPreorderDataScript) {
    try {
      this.variantPreorderData = JSON.parse(variantPreorderDataScript.textContent);
    } catch (e) {
      console.error('Error parsing products data:', e);
    }
  }
  if (this.variantPreorderData[event.detail.variant.id].preorder) {
    addToCartButtonElement.innerHTML = "Pre-Order";
    
    variantPreorderMessage.style.display = 'flex';
    variantPreorderMessage.innerText = this.variantPreorderData[event.detail.variant.id].product_message;
    variantPreorderProperty.setAttribute( 'name','properties[Pre-order]');
    variantPreorderProperty.value = this.variantPreorderData[event.detail.variant.id].checkout_message;
  } else {
    variantPreorderMessage.style.display = 'none';
    variantPreorderMessage.innerText = '';
    variantPreorderProperty.setAttribute( 'name','properties_null[Pre-order]');
    variantPreorderProperty.value = '';
  }
});

document.addEventListener("DOMContentLoaded", function(event) {
  const passwordError = document.querySelector(".pdp-password #pdp-password-error");
  const passwordInput = document.querySelector(".pdp-password input");
  const passwordSubmit = document.querySelector(".pdp-password button");

  document.querySelector(".pdp-password").addEventListener("submit", function(e){
    e.preventDefault();
    localStorage.setItem('tfCmpgnChck', passwordInput.value.toLowerCase());

    const keyToCheck = 'tfCmpgnChck';
    if (localStorage.getItem(keyToCheck) !== null) {
      const checkValue = localStorage.getItem(keyToCheck);
      if (checkValue == 'eliteviph3access') {
        console.log('promotion unlocked!');
        document.querySelector('.pdp-password').remove();
        passwordError.innerText = '';
      } else {
        passwordError.innerText = 'Incorrect password';
      }
    } 
  });

  const keyToCheck = 'tfCmpgnChck';
  if (localStorage.getItem(keyToCheck) !== null) {
    const checkValue = localStorage.getItem(keyToCheck);
    if (checkValue == 'eliteviph3access') {
      console.log('promotion unlocked!');
      document.querySelector('.pdp-password').remove();
      document.querySelector('.product').style.opacity = "1";
      document.querySelector('.product').style.pointerEvents = "all";
    } else {
      document.querySelector('.product').style.opacity = "1";
      document.querySelector('.product').style.pointerEvents = "all";
    }
  } else {
    document.querySelector('.product').style.opacity = "1";
    document.querySelector('.product').style.pointerEvents = "all";
  }

});